import * as React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Trans } from 'react-i18next';
import { pageWrapper, EEventNames } from '../../../../../client/analytics';
import Overview from '../../../../common/components/overview';
import Container from '../../../../common/components/container';
import Bar from '../../../../common/components/bar';
import BrandingForm from '../../forms/branding';
import * as organisationSelector from '../../../organisation/selectors/organisation';
import * as userSelector from '../../../core/selectors/logged-user';
import type { StoreState } from '../../../../common/types/store';

const mapStateToProps = (state: StoreState) => ({
  loggedUser: userSelector.selected(state),
  organisation: organisationSelector.selected(state),
});

const connector = connect(mapStateToProps);

type Props = ConnectedProps<typeof connector>;

const OrganisationBrandingSettings = ({ loggedUser, organisation }: Props) => (
  <Container name="SettingsLanguage">
    <Container.Content>
      <Bar>
        <h2><Trans i18nKey="organisation:settings_index_branding_title" /></h2>
      </Bar>
      <Overview>
        <Overview.Content>
          {/* @ts-expect-error */}
          <BrandingForm organisation={organisation} loggedUser={loggedUser} />
        </Overview.Content>
      </Overview>
    </Container.Content>
  </Container>
);

const tracker = pageWrapper(EEventNames.VISITED_ORGANISATION_SETTINGS_LANGUAGE_PAGE);

export const OrganisationBrandingSettingsContainer = connector(tracker(OrganisationBrandingSettings));
